import { AssociationTaskFormsComponentConfig } from './shared/association-task-forms-component.config.service';
import { Component, OnInit, Input, ViewChild, TemplateRef, Output, EventEmitter, OnDestroy } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { AsociacionTareaForma, BaseControl, FormaTabla, ConfirmComponent } from '@app/shared';
import { AssociationTaskFormsService } from './shared/association-task-forms-component.forms.service';
import { find } from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'iw-association-task-forms',
  templateUrl: './association-task-forms.component.html',
  styleUrls: ['./association-task-forms.component.scss'],
  providers: [AssociationTaskFormsService]
})
export class AssociationTaskFormsComponent implements OnInit, OnDestroy {

  // Entrada de las formas asociadas
  @Input() associations: Array<AsociacionTareaForma> = [];
  // Contiene las formas y sus versiones
  @Input() formsVersions: Array<FormaTabla> = [];
  // Mensaje de la accion a realizar en el formulario de asociacion
  actionForm = '';
  // Forma temporalmete seleccionada
  formSelected = '';
  // Pregunta de la modal
  question = '';
  // Index del registro de asociacion seleccionado
  indexSelected = -1;
  // Define cuando se muestra el formulario para agregar o modificar la asociacion
  formAssociation = false;
  // Define cuando se modifica la asociacion o se agrega una nueva
  associationEdit = false;
  // Configuracion de la tabla
  settings = {};
  // Formas asociadas
  formsAssociations: Array<AsociacionTareaForma> = [];
  // Lista de las formas
  formsList: Array<{key: string, value: string}> = [];
  // Contiene los controles de el formulario de asociaciones
  controls: BaseControl<any>[] = [];
  // Contiene la asociacion selecionada
  associationSelect: AsociacionTareaForma;
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // Referencia de la modal
  modalRef: BsModalRef;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild('ngSelect') ngSelectTpl: TemplateRef<any>;
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;
  // Salida del evento de guardar las asociciones
  @Output() saveAssociation: EventEmitter<Array<AsociacionTareaForma>> = new EventEmitter();

  constructor(
    private atfs: AssociationTaskFormsService,
    private toastr: ToastrService,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    if (this.associations && this.associations.length) {
      this.associations.forEach(asociation => {
        this.formsAssociations.push(asociation);
      });
    }

    const configTable = new AssociationTaskFormsComponentConfig();
    this.settings = configTable.settings;
    configTable.accion.subscribe((res: any) => {
      this.defineActionAssociation(res.action, res.data);
    });
    this.loadingAssociations();

    if (this.formsVersions.length) {
      this.formsVersions.forEach(form => {
        form.versiones.sort((a, b) => a.version - b.version);
        this.formsList.push({
          key: form.nombre,
          value: form.nombre
        });
      });
    }

  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Carga de forma correcta la lista de asociaciones para mostrar en la tabla
   *
   * @memberof AssociationTaskFormsComponent
   */
  loadingAssociations() {
    this.formsAssociations.forEach((association, index) => {
      association.index = index;
    });
    this.sourceData = new LocalDataSource(this.formsAssociations);
    this.sourceData.refresh();
  }

  /**
   * Define la accion a realizar para la asociacion
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @memberof AssociationTaskFormsComponent
   */
  defineActionAssociation(action: 'add' | 'update' | 'delete' = 'add', data?: any) {
    switch (action) {
      case 'add':
        this.formAssociation = true;
        this.associationEdit = false;
        this.actionForm = 'Agregar';
        this.controls = this.atfs.getFormAssociations(this.ngSelectTpl, {formsList: this.formsList});
        break;
      case 'update':
        this.formAssociation = true;
        this.associationEdit = true;
        this.associationSelect = data;
        this.formSelected = this.associationSelect.nombreForma;
        this.indexSelected = this.associationSelect.index;
        const versionForma: Array<{key: string, value: number}> = this.getVersionsForm();
        this.controls = this.atfs.getFormAssociations(
          this.ngSelectTpl,
          {formsList: this.formsList, formVersion: versionForma},
          this.associationSelect
        );
        this.actionForm = 'Modificar';
        break;
      case 'delete':
        this.associationSelect = data;
        this.indexSelected = this.associationSelect.index;
        this.question = '¿Realmente desea eliminar la asociacion?';
        this.confirm.open();
        break;
    }
  }

  /**
   * Cierra el formulario de asociacion
   *
   * @memberof AssociationTaskFormsComponent
   */
  closeFormAssociation() {
    this.formAssociation = false;
    this.formSelected = '';
    if (this.associationEdit) {
      this.indexSelected = -1;
      this.associationEdit = false;
      delete this.associationSelect;
    }
  }

  /**
   * Detecta el cambio de la forma seleccionada para cargar sus respectivas versiones
   *
   * @param {*} data
   * @memberof AssociationTaskFormsComponent
   */
  changeForm(data: any) {
    if (data.change) {
      if (this.formSelected !== data.change.cboForm) {
        this.formSelected = data.change.cboForm;
        let tempSelect: AsociacionTareaForma;
        const versionForma: Array<{key: string, value: number}> = this.getVersionsForm();

        tempSelect = {
          nombreForma: this.formSelected,
          aliasAsociacion: data.change.txtAliasTask,
          idForma: null,
          version: null
        };

        this.controls = this.atfs.getFormAssociations(
          this.ngSelectTpl,
          {formsList: this.formsList, formVersion: versionForma},
          tempSelect
        );
      }
    }
  }

  /**
   * Retorna las versiones de la forma seleccionada
   *
   * @returns {Array<{key: string, value: number}>}
   * @memberof AssociationTaskFormsComponent
   */
  getVersionsForm(): Array<{key: string, value: number}> {
    const versionForma: Array<{key: string, value: number}> = [];

    for (const form of this.formsVersions) {
      if (form.nombre === this.formSelected) {
        form.versiones.forEach(versionF => {
          versionForma.push({
            key: 'Version ' + versionF.version,
            value: versionF.id
          });
        });
        break;
      }
    }
    return versionForma;
  }

  /**
   * Guarda o atualiza la asociacion
   *
   * @param {*} data
   * @memberof AssociationTaskFormsComponent
   */
  sended(data: any) {
    const associationDuplicate = find(this.formsAssociations, {aliasAsociacion: data.txtAliasTask});
    const form = find(this.formsVersions, {nombre: data.cboForm});
    let versionF = 1;
    let valid = true;
    if (form) {
      versionF = find(form.versiones, {id: data.cboVersion}).version;
    }
    if (!this.associationEdit) {
      if (!associationDuplicate) {
        this.formsAssociations.push({
          idForma: data.cboVersion,
          nombreForma: data.cboForm,
          aliasAsociacion: data.txtAliasTask,
          version: versionF
        });
      } else {
        valid = false;
        this.toastr.warning('El alias ingresado ya se encuentra siendo utilizado por otra asociacion de forma',
                            'Duplicacion de alias');
      }
    } else {
      if (!associationDuplicate || associationDuplicate.index === this.indexSelected) {
        const newAssociation: AsociacionTareaForma = {
          idForma: data.cboVersion,
          nombreForma: data.cboForm,
          aliasAsociacion: data.txtAliasTask,
          version: versionF
        };
        this.formsAssociations[this.indexSelected] = newAssociation;
      } else {
        valid = false;
        this.toastr.warning('El alias ingresado ya se encuentra siendo utilizado por otra asociacion de forma',
                            'Duplicacion de alias');
      }
    }
    if (valid) {
      this.loadingAssociations();
      this.closeFormAssociation();
    }
  }

  /**
   * Elimina la asociacion
   *
   * @memberof AssociationTaskFormsComponent
   */
  deleteAssociation() {
    this.formsAssociations.splice(this.indexSelected, 1);
    this.loadingAssociations();
    this.closeFormAssociation();
  }

  /**
   * Controla la respuesta de confirmacion
   *
   * @param {boolean} res
   * @memberof AssociationTaskFormsComponent
   */
  actionComfirm(res: boolean) {
    if (res) {
      this.deleteAssociation();
    }
    this.question = '';
  }

  /**
   * Emite el evento de guardar las asociaciones en la forma principal
   *
   * @memberof AssociationTaskFormsComponent
   */
  saved() {
    this.saveAssociation.emit(this.formsAssociations);
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/association-task-forms/association-task-forms.component.ts